<template>
    <InfoPageLayout title="Contact Us" :content="contactUs?.content" />
</template>

<script setup>
import InfoPageLayout from '@/components/layouts/InfoPageLayout.vue';
import { ref } from 'vue';
import { getContactUs } from '@/services/pageService';

const contactUs = ref(null);

getContactUs().then(response => {
    contactUs.value = response.data;
});
</script>
